import styled from "styled-components";
import { colors, font, radius } from "../../styles/theme/tokens";

export const TopWrapper = styled.div`
   display: flex;
   align-items: center;
   gap: 12px;
   margin-bottom: 32px;

   @media (max-width: 768px) {
      margin-bottom: 24px;
   }
`

export const TitleWrapper = styled.div`
   display: flex;
   flex-direction: column;
   gap: 2px;
   min-width: 0;
`

export const Title = styled.h1`
   font-family: ${font.text};
   font-size: 26px;
   font-weight: 800;
   line-height: 1.2;
   color: ${colors.ink};

   @media (max-width: 768px) {
      font-size: 22px;
   }
`

export const EnglishLevel = styled.p`
   font-family: ${font.text};
   font-size: 13px;
   font-weight: 600;
   color: ${colors.muted};
   text-transform: capitalize;

   &::before {
      content: 'Рівень: ';
   }
`

export const BackButton = styled.button`
   display: grid;
   place-items: center;
   width: 40px;
   height: 40px;
   flex-shrink: 0;
   border-radius: ${radius.pill};
   color: ${colors.ink};
   background: ${colors.surface};
   border: 1.5px solid ${colors.line};
   cursor: pointer;
   transition: border-color 0.15s ease;

   &:hover {
      border-color: ${colors.brand};
   }
`

export const Spacer = styled.div`
   flex: 1;
`
